import React,{useState,useEffect} from "react";
import { Badge, Card,CardBody,Table,Row,Col} from "reactstrap";
  import ReactBSAlert from "react-bootstrap-sweetalert";
  import {TEMPLATES_BY_CLIENT,TEMPLATES_APPROVE} from "../../constants"
import axios from "axios";


const SmsApproval=()=>{
    const [alert, setAlert] = useState(null);
    const [templates, setTemplates] = useState([]);



    useEffect(()=>{
      getPendingTemplates();
    },[])

    const getPendingTemplates=()=>{
      console.log("---31");
      let payload={
        channels_type:"sms"
      }
      axios.post(TEMPLATES_BY_CLIENT,payload).then(res=>setTemplates(res?.data)).catch((err)=>console.log(err))
    }
    const confirmdeleteUser = (id) =>{
     
         setAlert(<ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure?"
            onConfirm={() =>approveTemplate(id)}
            onCancel={() => setAlert(null)}
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            confirmBtnText="Yes, Approve"
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          >
              You want to Approve This Template ?
          </ReactBSAlert>
          );
      }
      const approveTemplate=(id)=>{
        let payload = {
          id:id.toString()
        }
        axios.post(TEMPLATES_APPROVE,payload).then(res=>console.log("-->",res)).catch(err=>console.log(err))
      }
    return (
      <>
        <div className="content pd-0 ">
        {alert}
          <Row className="Roles">
            <Card>
              <CardBody className="scroll-height-450">
                <Col sm="12">
                  <Row>
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>Client</th>
                          <th>Template Id</th>
                          <th>Content</th>
                          <th>Sender Id</th>
                          <th>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {
                          console.log("----->",templates.data)
                        }
                        {
                          templates?.map((item,index)=>{
                            let smstemplate="";
                            let content="";
                            let senderIds="";

                            return(
                              <tr>
                                
                                 <td style={{width: "33%"}}> {item.company_name}</td>
                                 {
                                  item?.templates?.map((temp,i)=>{
                                    // a.push( <td > {item.company_name}</td>)
                                 smstemplate +=   temp.smstemplate+"\n"
                                 content +=   temp.smscontent+"\n"
                                 temp?.smssenderArr?.map((sendr,i)=>{
                                  
                                  senderIds += sendr.smssenderId+"\n"
                                 })
                                 
                                  })
                                 }
                                  <td style={{wordBreak: "break-word"}} > {smstemplate}</td>
                                  <td style={{wordBreak: "break-word"}} > {content}</td>
                                  <td style={{wordBreak: "break-word"}} > {senderIds}</td>
                                 <td>
                                
                            <Badge
                              className="badge badge-warning"
                              color="success"
                              onClick={()=>confirmdeleteUser(item.id)}
                              style={{cursor:"pointer"}}
                            >
                              Pending
                            </Badge>
                          </td>
                              </tr>
                            )
                          })
                        }
                        {/* <tr>
                            <td >TDR </td>
                            <td>Temp345</td>
                            <td>Temp</td>
                            <td>765432</td>
                          <td>
                            <Badge
                              className="badge badge-warning"
                              color="success"
                              onClick={()=>confirmdeleteUser(2)}
                              style={{cursor:"pointer"}}
                            >
                              Pending
                            </Badge>
                          </td>
                        </tr> */}
                      </tbody>
                    </Table>
                  </Row>
                </Col>
              </CardBody>
            </Card>
          </Row>
        </div>
      </>
    );
}

export default SmsApproval;